import { HackathonData } from './data_types';

const year2025: HackathonData = {
  year: 2025,
  applicants: {
    numApplicants: 1826, // (1316 were accepted)
    acceptanceRate: 72.1,
  },
  gender: {
    genderMale: 62.21, // 817 / 1316
    genderFemale: 26.29, // 346 / 1316
    genderNonBinary: 0.84, // 11 / 1316
    genderDidNotIdentify: 10.66,
  },
  ethnicity: [
    {
      ethnicityType: 'White',
      totalEthnicity: 9.35, // 123 /1316
    },
    {
      ethnicityType: 'Black',
      totalEthnicity: 2.13, // 28 / 1316
    },
    {
      ethnicityType: 'Latinx/Hispanic',
      totalEthnicity: 3.04, // 40 / 1316
    },
    {
      ethnicityType: 'East Asian',
      totalEthnicity: 25.76, // 339 / 1316
    },
    {
      ethnicityType: 'Southeast Asian',
      totalEthnicity: 12.31, // 162 / 1316
    },
    {
      ethnicityType: 'South Asian',
      totalEthnicity: 30.32, // 399 / 1316
    },
    {
      ethnicityType: 'Middle Eastern/North African',
      totalEthnicity: 2.58, // 34 / 1316
    },
    {
      ethnicityType: 'Other',
      totalEthnicity: 3.26,
    },
    {
      ethnicityType: 'Did not specify',
      totalEthnicity: 11.25, // (148/1316)
    },
  ],
  graduatingClass: {
    // other?
    // 2025 and 2026 count as seniors;
    // 2029 and 2030 count as freshman
    // all else is same; some people aren’t undergrad (still counted those so ~ error)
    yearFreshman: 15.3,
    yearSophomore: 23.4,
    yearJunior: 38.6,
    yearSenior: 22.6,
  },
  // because majors are multi select, for every major selected by one person, it  // is tallied up as a fraction of one major (e.g. if Person X selects CS,BIO,Chem, CS // gets tallied 0.33, Bio 0.33, Chem 0.33)
  topMajors: [
    {
      majorName: 'Computer Science/Computer Engineering',
      totalMajor: 71.2, // (937 / 1316)
    },
    {
      majorName: 'Informatics/Data Science',
      totalMajor: 8.28, // (109 / 1316)
    },
    {
      majorName: 'Math/Statistics',
      totalMajor: 5.78, // (76 / 1316)
    },
    {
      majorName: 'Another Engineering Discipline',
      totalMajor: 4.79, // (63 / 1316)
    },
    {
      majorName: 'Business',
      totalMajor: 1.67, // (22 / 1316)
    },
    {
      majorName: 'Biology/Chemistry/Physics',
      totalMajor: 1.11, // (15 / 1316)
    },
    {
      majorName: 'Other', // (94 majors + undeclared)
      totalMajor: 7.14,
    },
  ],
  topSchools: [
    {
      schoolName: 'UW-Seattle',
      totalSchool: 66.03, // 869 / 1316
    },
    {
      schoolName: 'UW-Bothell',
      totalSchool: 4.64, // 61 /1316
    },
    {
      schoolName: 'Oregon State University',
      totalSchool: 4.33, // 57 / 1316
    },
    {
      schoolName: 'University of British Columbia',
      totalSchool: 3.19, // 42 /1316
    },
    {
      schoolName: 'Purdue University',
      totalSchool: 1.14, // 15/1316
    },
    {
      schoolName: 'Other',
      totalSchool: 20.67,
    },
  ],
};

const year2024: HackathonData = {
  year: 2024,
  applicants: {
    numApplicants: 1265, // (1176 were accepted)
    acceptanceRate: 93.0,
  },
  gender: {
    genderMale: 58.16,
    genderFemale: 28.32,
    genderNonBinary: 1.74,
    genderDidNotIdentify: 11.78,
  },
  ethnicity: [
    {
      ethnicityType: 'White',
      totalEthnicity: 9.35,
    },
    {
      ethnicityType: 'Black',
      totalEthnicity: 2.01,
    },
    {
      ethnicityType: 'Latinx/Hispanic',
      totalEthnicity: 3.59,
    },
    {
      ethnicityType: 'East Asian',
      totalEthnicity: 27.98,
    },
    {
      ethnicityType: 'Southeast Asian',
      totalEthnicity: 14.94,
    },
    {
      ethnicityType: 'South Asian',
      totalEthnicity: 23.53,
    },
    {
      ethnicityType: 'Middle Eastern/North African',
      totalEthnicity: 1.28,
    },
    {
      ethnicityType: 'Other',
      totalEthnicity: 2.35,
    },
    {
      ethnicityType: 'Did not specify',
      totalEthnicity: 14.97,
    },
  ],
  graduatingClass: {
    // other?
    // 2024 and 2025 count as seniors;
    // 2028 and 2029 count as freshman
    // all else is same; some people aren’t undergrad (still counted those so ~ error)
    yearFreshman: 17.3,
    yearSophomore: 25.8,
    yearJunior: 35.1,
    yearSenior: 21.8,
  },
  // because majors are multi select, for every major selected by one person, it  // is tallied up as a fraction of one major (e.g. if Person X selects CS,BIO,Chem, CS // gets tallied 0.33, Bio 0.33, Chem 0.33)
  topMajors: [
    {
      majorName: 'Computer Science/Computer Engineering',
      totalMajor: 71.22,
    },
    {
      majorName: 'Informatics/Data Science',
      totalMajor: 6.09,
    },
    {
      majorName: 'Math/Statistics',
      totalMajor: 2.88,
    },
    {
      majorName: 'Business',
      totalMajor: 1.89,
    },
    {
      majorName: 'Other', // (56 majors + undeclared)
      totalMajor: 17.92,
    },
  ],
  topSchools: [
    {
      schoolName: 'UW-Seattle',
      totalSchool: 75.43,
    },
    {
      schoolName: 'UW-Bothell',
      totalSchool: 4.42,
    },
    {
      schoolName: 'Arizona State University',
      totalSchool: 2.64,
    },
    {
      schoolName: 'University of British Columbia',
      totalSchool: 2.21,
    },
    {
      schoolName: 'Other',
      totalSchool: 15.3,
    },
  ],
};

const year2023: HackathonData = {
  year: 2023,
  applicants: {
    numApplicants: 1262,
    acceptanceRate: 90.5,
  },
  gender: {
    genderMale: 56.57,
    genderFemale: 30.74,
    genderNonBinary: 1.75,
    genderDidNotIdentify: 10.94,
  },
  ethnicity: [
    {
      ethnicityType: 'White',
      totalEthnicity: 9.72,
    },
    {
      ethnicityType: 'Black',
      totalEthnicity: 2.63,
    },
    {
      ethnicityType: 'Latinx/Hispanic',
      totalEthnicity: 3.68,
    },
    {
      ethnicityType: 'East Asian',
      totalEthnicity: 29.16,
    },
    {
      ethnicityType: 'Southeast Asian',
      totalEthnicity: 13.57,
    },
    {
      ethnicityType: 'South Asian',
      totalEthnicity: 18.83,
    },
    {
      ethnicityType: 'Middle Eastern/North African',
      totalEthnicity: 1.84,
    },
    {
      ethnicityType: 'Mixed',
      totalEthnicity: 7.27,
    },
    {
      ethnicityType: 'Did not specify',
      totalEthnicity: 13.3,
    },
  ],
  graduatingClass: {
    // other?
    yearFreshman: 18.3,
    yearSophomore: 24.7,
    yearJunior: 34.31,
    yearSenior: 18.91,
  },
  topMajors: [
    {
      majorName: 'Computer Science/Computer Engineering',
      totalMajor: 73.91,
    },
    {
      majorName: 'Informatics/Data Science',
      totalMajor: 6.65,
    },
    {
      majorName: 'Design/HCDE',
      totalMajor: 4.72,
    },
    {
      majorName: 'Business',
      totalMajor: 3.33,
    },
    {
      majorName: 'Other',
      totalMajor: 9.37,
    },
  ],
  topSchools: [
    {
      schoolName: 'UW-Seattle',
      totalSchool: 77.93,
    },
    {
      schoolName: 'UW-Bothell',
      totalSchool: 7.62,
    },
    {
      schoolName: 'University of British Columbia',
      totalSchool: 4.64,
    },
    {
      schoolName: 'Washington State University',
      totalSchool: 3.5,
    },
    {
      schoolName: 'Other',
      totalSchool: 6.31,
    },
  ],
};

const year2022: HackathonData = {
  year: 2022,
  applicants: {
    numApplicants: 1179,
    acceptanceRate: 84.4,
  },
  gender: {
    genderMale: 51.6,
    genderFemale: 34.33,
    genderNonBinary: 1.1,
    genderDidNotIdentify: 12.95,
  },
  ethnicity: [
    {
      ethnicityType: 'White',
      totalEthnicity: 10.84,
    },
    {
      ethnicityType: 'Black',
      totalEthnicity: 2.1,
    },
    {
      ethnicityType: 'Latinx/Hispanic',
      totalEthnicity: 3.21,
    },
    {
      ethnicityType: 'East Asian',
      totalEthnicity: 30.62,
    },
    {
      ethnicityType: 'Southeast Asian',
      totalEthnicity: 13.25,
    },
    {
      ethnicityType: 'South Asian',
      totalEthnicity: 15.96,
    },
    {
      ethnicityType: 'Middle Eastern/North African',
      totalEthnicity: 3.01,
    },
    {
      ethnicityType: 'Mixed',
      totalEthnicity: 7.73,
    },
    {
      ethnicityType: 'Did not specify',
      totalEthnicity: 11.44,
    },
  ],
  graduatingClass: {
    // yearHighSchool: 2.29,
    yearFreshman: 18.27,
    yearSophomore: 25.6,
    yearJunior: 32.42,
    yearSenior: 20.18,
  },
  topMajors: [
    {
      majorName: 'Computer Science',
      totalMajor: 63.65,
    },
    {
      majorName: 'Informatics/Data Science',
      totalMajor: 13.25,
    },
    {
      majorName: 'Electrical/Computer Engineering',
      totalMajor: 7.63,
    },
    {
      majorName: 'Design/HCDE',
      totalMajor: 4.51,
    },
    {
      majorName: 'Business',
      totalMajor: 4.01,
    },
  ],
  topSchools: [
    {
      schoolName: 'UW-Seattle',
      totalSchool: 80.72,
    },
    {
      schoolName: 'UW-Bothell',
      totalSchool: 3.21,
    },
    {
      schoolName: 'Western Washington University',
      totalSchool: 1.7,
    },
    {
      schoolName: 'Bellevue College',
      totalSchool: 1.4,
    },
    {
      schoolName: 'Highline Community College',
      totalSchool: 1.2,
    },
  ],
};

const year2021: HackathonData = {
  year: 2021,
  applicants: {
    numApplicants: 845,
    acceptanceRate: 85.9,
  },
  gender: {
    genderMale: 47.38,
    genderFemale: 30.57,
    genderNonBinary: 1.37,
    genderDidNotIdentify: 20.66,
  },
  ethnicity: [
    {
      ethnicityType: 'White',
      totalEthnicity: 8.67,
    },
    {
      ethnicityType: 'Black',
      totalEthnicity: 1.37,
    },
    {
      ethnicityType: 'Latinx/Hispanic',
      totalEthnicity: 3.16,
    },
    {
      ethnicityType: 'East Asian',
      totalEthnicity: 30.02,
    },
    {
      ethnicityType: 'Southeast Asian',
      totalEthnicity: 9.09,
    },
    {
      ethnicityType: 'South Asian',
      totalEthnicity: 13.49,
    },
    {
      ethnicityType: 'Middle Eastern/North African',
      totalEthnicity: 2.47,
    },
    {
      ethnicityType: 'Mixed',
      totalEthnicity: 3.44,
    },
    {
      ethnicityType: 'Did not specify',
      totalEthnicity: 27.54,
    },
  ],
  graduatingClass: {
    yearFreshman: 23.69,
    yearSophomore: 27.27,
    yearJunior: 28.37,
    yearSenior: 20.66,
  },
  topMajors: [
    {
      majorName: 'Computer Science',
      totalMajor: 57.3,
    },
    {
      majorName: 'Informatics/Data Science',
      totalMajor: 15.7,
    },
    {
      majorName: 'Electrical/Computer Engineering',
      totalMajor: 9.77,
    },
    {
      majorName: 'Design',
      totalMajor: 3.3,
    },
    {
      majorName: 'Business',
      totalMajor: 2.89,
    },
  ],
  topSchools: [
    {
      schoolName: 'UW-Seattle',
      totalSchool: 84.29,
    },
    {
      schoolName: 'UW-Bothell',
      totalSchool: 4.4,
    },
    {
      schoolName: 'Washigton State University - Tri-Cities',
      totalSchool: 1.5,
    },
    {
      schoolName: 'UW-Tacoma',
      totalSchool: 0.96,
    },
  ],
};

const year2020: HackathonData = {
  year: 2020,
  applicants: {
    acceptanceRate: 97.6,
  },
  gender: {
    genderMale: 58.8,
    genderFemale: 34.8,
    genderNonBinary: 1.99,
    genderDidNotIdentify: 4.35,
  },
  ethnicity: [
    {
      ethnicityType: 'White',
      totalEthnicity: 10.64,
    },
    {
      ethnicityType: 'Black',
      totalEthnicity: 2.4,
    },
    {
      ethnicityType: 'Latinx/Hispanic',
      totalEthnicity: 3,
    },
    {
      ethnicityType: 'East Asian',
      totalEthnicity: 33.5,
    },
    {
      ethnicityType: 'Southeast Asian',
      totalEthnicity: 11.7,
    },
    {
      ethnicityType: 'South Asian',
      totalEthnicity: 17.6,
    },
    {
      ethnicityType: 'Middle Eastern/North African',
      totalEthnicity: 2.54,
    },
    {
      ethnicityType: 'Mixed',
      totalEthnicity: 6.53,
    },
    {
      ethnicityType: 'Did not specify',
      totalEthnicity: 10,
    },
  ],
  graduatingClass: {
    // yearHighSchool: 2.29,
    yearFreshman: 12.69,
    yearSophomore: 26.36,
    yearJunior: 36.6,
    yearSenior: 23.2,
  },
  topMajors: [
    {
      majorName: 'Computer Science',
      totalMajor: 59.3,
    },
    {
      majorName: 'Informatics',
      totalMajor: 6,
    },
    {
      majorName: 'Electrical Engineering',
      totalMajor: 11.9,
    },
    {
      majorName: 'Data Science',
      totalMajor: 9.67,
    },
    {
      majorName: 'Business',
      totalMajor: 5.68,
    },
    {
      majorName: 'Design',
      totalMajor: 5.56,
    },
  ],
  topSchools: [
    {
      schoolName: 'UW-Seattle',
      totalSchool: 46.7,
    },
    {
      schoolName: 'UW-Bothell',
      totalSchool: 3.5,
    },
    {
      schoolName: 'UW-Tacoma',
      totalSchool: 1.51,
    },
    {
      schoolName: 'U British Columbia',
      totalSchool: 6.2,
    },
    {
      schoolName: 'U Waterloo',
      totalSchool: 2,
    },
  ],
};

const year2019: HackathonData = {
  year: 2019,
  applicants: {
    numApplicants: 1602,
    acceptanceRate: 65,
  },
  gender: {
    genderMale: 60,
    genderFemale: 33,
    genderNonBinary: 7,
  },
  ethnicity: [
    {
      ethnicityType: 'White or Euro-American',
      totalEthnicity: 14,
    },
    {
      ethnicityType: 'Black, Afro-Caribbean, or African-American',
      totalEthnicity: 2,
    },
    {
      ethnicityType: 'LatinX or Hispanic-American',
      totalEthnicity: 2,
    },
    {
      ethnicityType: 'South Asian or Asian-American',
      totalEthnicity: 21,
    },
    {
      ethnicityType: 'East Asian or Asian-American',
      totalEthnicity: 45,
    },
  ],
  graduatingClass: {
    yearFreshman: 15,
    yearSophomore: 29,
    yearJunior: 33,
    yearSenior: 24,
  },
  topMajors: [
    {
      majorName: 'Computer Science',
      totalMajor: 72,
    },
    {
      majorName: 'Computer Engineering',
      totalMajor: 9,
    },
    {
      majorName: 'Electrical Engineering',
      totalMajor: 6,
    },
    {
      majorName: 'Informatics',
      totalMajor: 5,
    },
    {
      majorName: 'Mathematics',
      totalMajor: 1,
    },
  ],
  topSchools: [
    {
      schoolName: 'University of Washington',
      totalSchool: 55,
    },
    {
      schoolName: 'University of British Columbia',
      totalSchool: 7,
    },
    {
      schoolName: 'UC Berkeley',
      totalSchool: 3,
    },
    {
      schoolName: 'Washington State University',
      totalSchool: 3,
    },
    {
      schoolName: 'University of California-Irvine',
      totalSchool: 2,
    },
  ],
};

const year2018: HackathonData = {
  year: 2018,
  applicants: {
    numApplicants: 1300,
    acceptanceRate: 63,
  },
  gender: {
    genderMale: 49,
    genderFemale: 23,
    genderNonBinary: 1,
    genderDidNotIdentify: 27,
  },
  ethnicity: [
    {
      ethnicityType: 'East Asian or Asian-American',
      totalEthnicity: 43,
    },
    {
      ethnicityType: 'South Asian or Asian-American',
      totalEthnicity: 23,
    },
    {
      ethnicityType: 'White or Euro-American',
      totalEthnicity: 14,
    },
    {
      ethnicityType: 'LatinX or Hispanic-American',
      totalEthnicity: 4,
    },
    {
      ethnicityType: 'Black, Afro-Caribbean, or African-American',
      totalEthnicity: 2,
    },
    {
      ethnicityType: 'Middle Eastern or North African',
      totalEthnicity: 2,
    },
    {
      ethnicityType: 'Hawaiian or Pacific Islander',
      totalEthnicity: 1,
    },
    {
      ethnicityType: 'Other',
      totalEthnicity: 5,
    },
  ],
  graduatingClass: {
    yearFreshman: 31,
    yearSophomore: 30,
    yearJunior: 23,
    yearSenior: 14,
  },
  topMajors: [
    {
      majorName: 'Computer Science',
      totalMajor: 43,
    },
    {
      majorName: 'Computer Engineering',
      totalMajor: 5,
    },
    {
      majorName: 'Electrical Engineering',
      totalMajor: 1,
    },
    {
      majorName: 'Informatics',
      totalMajor: 7,
    },
    {
      majorName: 'Pre-Science',
      totalMajor: 1,
    },
  ],
  topSchools: [
    {
      schoolName: 'University of Washington',
      totalSchool: 55,
    },
    {
      schoolName: 'University of British Columbia',
      totalSchool: 8,
    },
    {
      schoolName: 'UC Berkeley',
      totalSchool: 2,
    },
    {
      schoolName: 'University of Southern California',
      totalSchool: 1,
    },
    {
      schoolName: 'University of Texas - Austin',
      totalSchool: 1,
    },
  ],
};

const year2017: HackathonData = {
  year: 2017,
  applicants: {
    numApplicants: 1800,
    acceptanceRate: 63,
  },
  gender: {
    genderMale: 70,
    genderFemale: 28,
    genderNonBinary: 2,
  },
  ethnicity: [
    {
      ethnicityType: 'East Asian or Asian-American',
      totalEthnicity: 37,
    },
    {
      ethnicityType: 'South Asian or Asian-American',
      totalEthnicity: 26,
    },
    {
      ethnicityType: 'White or Euro-American',
      totalEthnicity: 21,
    },
    {
      ethnicityType: 'LatinX or Hispanic-American',
      totalEthnicity: 6,
    },
    {
      ethnicityType: 'Black, Afro-Caribbean, or African-American',
      totalEthnicity: 2,
    },
    {
      ethnicityType: 'Middle Eastern or North African',
      totalEthnicity: 2,
    },
    {
      ethnicityType: 'Hawaiian or Pacific Islander',
      totalEthnicity: 1,
    },
    {
      ethnicityType: 'Other',
      totalEthnicity: 4,
    },
  ],
  graduatingClass: {
    yearFreshman: 30,
    yearSophomore: 32,
    yearJunior: 24,
    yearSenior: 12,
  },
  topMajors: [
    {
      majorName: 'Computer Science',
      totalMajor: 44,
    },
    {
      majorName: 'Computer Engineering',
      totalMajor: 6,
    },
    {
      majorName: 'Electrical Engineering',
      totalMajor: 2,
    },
    {
      majorName: 'Informatics',
      totalMajor: 6,
    },
    {
      majorName: 'Software Engineering',
      totalMajor: 2,
    },
  ],
  topSchools: [
    {
      schoolName: 'University of Washington',
      totalSchool: 55,
    },
    {
      schoolName: 'University of British Columbia',
      totalSchool: 4,
    },
    {
      schoolName: 'UC Berkeley',
      totalSchool: 2,
    },
    {
      schoolName: 'University of Waterloo',
      totalSchool: 2,
    },
    {
      schoolName: 'University of Florida',
      totalSchool: 2,
    },
  ],
};

const year2016: HackathonData = {
  year: 2016,
  applicants: {
    numApplicants: 1600,
    acceptanceRate: 44,
  },
  gender: {
    genderMale: 71,
    genderFemale: 26,
    genderNonBinary: 2,
  },
  ethnicity: [
    {
      ethnicityType: 'East Asian or Asian-American',
      totalEthnicity: 35,
    },
    {
      ethnicityType: 'South Asian or Asian-American',
      totalEthnicity: 25,
    },
    {
      ethnicityType: 'White or Euro-American',
      totalEthnicity: 24,
    },
    {
      ethnicityType: 'LatinX or Hispanic-American',
      totalEthnicity: 5,
    },
    {
      ethnicityType: 'Black, Afro-Caribbean, or African-American',
      totalEthnicity: 2,
    },
    {
      ethnicityType: 'Middle Eastern or North African',
      totalEthnicity: 2,
    },
    {
      ethnicityType: 'Hawaiian or Pacific Islander',
      totalEthnicity: 1,
    },
    {
      ethnicityType: 'Other',
      totalEthnicity: 6,
    },
  ],
  graduatingClass: {
    yearFreshman: 30,
    yearSophomore: 30,
    yearJunior: 26,
    yearSenior: 10,
  },
  topMajors: [
    {
      majorName: 'Computer Science',
      totalMajor: 44,
    },
    {
      majorName: 'Computer Engineering',
      totalMajor: 5,
    },
    {
      majorName: 'Electrical Engineering',
      totalMajor: 2,
    },
    {
      majorName: 'Informatics',
      totalMajor: 5,
    },
    {
      majorName: 'Software Engineering',
      totalMajor: 1,
    },
  ],
  topSchools: [
    {
      schoolName: 'University of Washington',
      totalSchool: 41,
    },
    {
      schoolName: 'University of British Columbia',
      totalSchool: 6,
    },
    {
      schoolName: 'UC Berkeley',
      totalSchool: 2,
    },
    {
      schoolName: 'Purdue University',
      totalSchool: 2,
    },
    {
      schoolName: 'University of Florida',
      totalSchool: 3,
    },
  ],
};

const year2015: HackathonData = {
  year: 2015,
  applicants: {
    numApplicants: 1500,
    acceptanceRate: 57,
  },
  gender: {
    genderMale: 76,
    genderFemale: 22,
    genderNonBinary: 1,
  },
  ethnicity: [],
  graduatingClass: {
    yearFreshman: 30,
    yearSophomore: 37,
    yearJunior: 22,
    yearSenior: 11,
  },
  topMajors: [
    {
      majorName: 'Computer Science',
      totalMajor: 45,
    },
    {
      majorName: 'Computer Engineering',
      totalMajor: 6,
    },
    {
      majorName: 'Electrical Engineering',
      totalMajor: 3,
    },
    {
      majorName: 'Informatics',
      totalMajor: 6,
    },
    {
      majorName: 'Software Engineering',
      totalMajor: 1,
    },
  ],
  topSchools: [
    {
      schoolName: 'University of Washington',
      totalSchool: 40,
    },
    {
      schoolName: 'University of British Columbia',
      totalSchool: 8,
    },
    {
      schoolName: 'University of Waterloo',
      totalSchool: 2,
    },
    {
      schoolName: 'Purdue University',
      totalSchool: 3,
    },
    {
      schoolName: 'Georgia Institute of Technology',
      totalSchool: 2,
    },
  ],
};

export const data = {
  2025: year2025,
  2024: year2024,
  2023: year2023,
  2022: year2022,
  2021: year2021,
  2020: year2020,
  2019: year2019,
  2018: year2018,
  2017: year2017,
  2016: year2016,
  2015: year2015,
};
